import styled from "styled-components";

export const FormFilterWrapper = styled.div`
  margin-bottom: 16px;
`;
export const HeaderItemWrapper = styled.div`
  .header__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .header__title {
      font-size: 18px;
      font-weight: 500;
    }
  }
`;

export const FormItemWrapper = styled.div`
  margin-top: 20px;
`;

export const IconActionWrapper = styled.div`
  display: flex;
  padding: 0 0 5px 0;
  justify-content: flex-end;
  svg {
    cursor: pointer;
  }
`;

export const CalendarMultiWrapper = styled.div`
  margin-top: 16px;
`;
export const SwitchMultiWrapper = styled.div`
  padding: 12px 0px 12px 0px;
  border-bottom: 1px solid rgb(236, 236, 236);
  .fui-Switch {
    width: 100%;
    justify-content: space-between;
  }
`;
